import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { CheckTutorial } from "./services/check-tutorial.service";

const routes: Routes = [
  //attempting to use tab page to display the tabs
  // {
  //   path: "",
  //   loadChildren: () =>
  //     import("./tabs/tabs.module").then((m) => m.TabsPageModule),
  // },
  // {
  //   path: "./",
  //   loadChildren: () =>
  //     import("./tabs/tabs.module").then((m) => m.TabsPageModule),
  // },
  // {
  //   path: "tabs",
  //   loadChildren: () =>
  //     import("./tabs/tabs.module").then((m) => m.TabsPageModule),
  // },
  {
    path: "",
    redirectTo: "tutorial",
    pathMatch: "full",
    canLoad: [CheckTutorial],
  },
  {
    path: "./",
    loadChildren: () =>
      import("./tutorial/tutorial.module").then((m) => m.TutorialModule),
    canLoad: [CheckTutorial],
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },

  {
    path: "registration",
    loadChildren: () =>
      import("./registration/registration.module").then(
        (m) => m.RegistrationPageModule
      ),
  },
  {
    path: "automatic/:id",
    loadChildren: () =>
      import("./automatic/automatic.module").then((m) => m.AutomaticPageModule),
  },
  {
    path: "manual/:id",
    loadChildren: () =>
      import("./manual/manual.module").then((m) => m.ManualPageModule),
  },
  {
    path: "verify-email",
    loadChildren: () =>
      import("./verify-email/verify-email.module").then(
        (m) => m.VerifyEmailPageModule
      ),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "items/:id",
    loadChildren: () =>
      import("./items/items.module").then((m) => m.ItemsPageModule),
  },
  {
    path: "item-dialog/:id",
    loadChildren: () =>
      import("./item-dialog/item-dialog.module").then(
        (m) => m.ItemDialogPageModule
      ),
  },

  {
    path: "profile",
    loadChildren: () =>
      import("./profile/profile.module").then((m) => m.ProfilePageModule),
  },
  {
    path: "guide",
    loadChildren: () =>
      import("./guide/tutorial.module").then((m) => m.TutorialModule),
  },

  {
    path: "tutorial",
    loadChildren: () =>
      import("./tutorial/tutorial.module").then((m) => m.TutorialModule),
    canLoad: [CheckTutorial],
  },
  {
    path: "edit/:id/:id2",
    loadChildren: () =>
      import("./edit/edit.module").then((m) => m.EditPageModule),
  },

  {
    path: "edit-profile",
    loadChildren: () =>
      import("./edit-profile/edit-profile.module").then(
        (m) => m.EditProfilePageModule
      ),
  },

  {
    path: "add-member",
    loadChildren: () =>
      import("./add-member/add-member.module").then(
        (m) => m.AddMemberPageModule
      ),
  },

  {
    path: "schedule",
    loadChildren: () =>
      import("./schedule/schedule.module").then((m) => m.SchedulePageModule),
  },
  {
    path: "lists",
    loadChildren: () =>
      import("./lists/lists.module").then((m) => m.ListsPageModule),
  },
  {
    path: "shared-list-items/:id",
    loadChildren: () =>
      import("./shared-list-items/shared-list-items.module").then(
        (m) => m.SharedListItemsPageModule
      ),
  },
  {
    path: "shared-lists/:id",
    loadChildren: () =>
      import("./shared-lists/shared-lists.module").then(
        (m) => m.SharedListsPageModule
      ),
  },
  {
    path: "shared-lists",
    loadChildren: () =>
      import("./shared-lists/shared-lists.module").then(
        (m) => m.SharedListsPageModule
      ),
  },

  {
    path: "create-list",
    loadChildren: () =>
      import("./create-list/create-list.module").then(
        (m) => m.CreateListPageModule
      ),
  },
  {
    path: "support",
    loadChildren: () =>
      import("./support/support.module").then((m) => m.SupportPageModule),
  },
  {
    path: "support-old",
    loadChildren: () =>
      import("./support-old/support.module").then((m) => m.SupportPageModule),
  },

  {
    path: "welcome",
    loadChildren: () =>
      import("./welcome/welcome.module").then((m) => m.WelcomePageModule),
  },
  {
    path: "welcome/:id",
    loadChildren: () =>
      import("./welcome/welcome.module").then((m) => m.WelcomePageModule),
  },

  {
    path: "group",
    loadChildren: () =>
      import("./group/group.module").then((m) => m.GroupPageModule),
  },

  {
    path: "announcement/:id",
    loadChildren: () =>
      import("./announcement/announcement.module").then(
        (m) => m.AnnouncementPageModule
      ),
  },

  {
    path: "chat/:id",
    loadChildren: () =>
      import("./chat/chat.module").then((m) => m.ChatPageModule),
  },
  {
    path: "chat-groups",
    loadChildren: () =>
      import("./chat-groups/chat-groups.module").then(
        (m) => m.ChatGroupsPageModule
      ),
  },

  {
    path: "archive",
    loadChildren: () =>
      import("./archive/archive.module").then((m) => m.ArchivePageModule),
  },
  {
    path: "pre-file",
    loadChildren: () =>
      import("./pre-file/pre-file.module").then((m) => m.PreFilePageModule),
  },
  {
    path: "switch-theme",
    loadChildren: () =>
      import("./switch-theme/switch-theme.module").then(
        (m) => m.SwitchThemePageModule
      ),
  },
  {
    path: "files/:id",
    loadChildren: () =>
      import("./files/files.module").then((m) => m.FilesPageModule),
  },
  {
    path: "files",
    loadChildren: () =>
      import("./files/files.module").then((m) => m.FilesPageModule),
  },
  {
    path: "payment",
    loadChildren: () =>
      import("./payment/payment.module").then((m) => m.PaymentPageModule),
  },
  {
    path: "card-pay",
    loadChildren: () =>
      import("./card-pay/card-pay.module").then((m) => m.CardPayPageModule),
  },
  {
    path: "group-details/:id",
    loadChildren: () =>
      import("./group-details/group-details.module").then(
        (m) => m.GroupDetailsPageModule
      ),
  },
  {
    path: "changes/:id",
    loadChildren: () =>
      import("./changes/changes.module").then((m) => m.ChangesPageModule),
  },

  {
    path: "places-map",
    loadChildren: () =>
      import("./places-map/places-map.module").then(
        (m) => m.PlacesMapPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
